export default __webpack_public_path__ + "static/media/image-gallery-1.602806e7.jpg";